export default "__VITE_ASSET__Ct2lFkU6__"